(function($) {

    // console.log( 'Vibber theme JS version 1' );

    /**
     * Mobile nav.
     */

    if ( $('.js-mobile-nav-toggle').length )
    {
        $('.js-mobile-nav-toggle').on( 'click', function ( event ) {
            // prevent default
            event.stopPropagation();
            event.preventDefault();
            //
            $('#nav-mobile').toggleClass('active');
            $('body').toggleClass('no-scrolling');
        });
    }

    /**
     * Scroll status.
     */

    function update_scroll_status()
    {
        var body = $( 'body' );
        var viewport_top = $( window ).scrollTop();

        if ( viewport_top > 0 )
        {
            body.addClass( 'scrolled' );
        }
        else
        {
            body.removeClass( 'scrolled' );
        }
    };

    update_scroll_status();

    $( window ).scroll( function() {
        update_scroll_status();
    });

    /**
     * Virtual pages XL.
     */

    if ( $('.js-vp').length )
    {
        function activate_virtual_page( id )
        {
            // set active select
            $('.js-vpm-select').val( id );
            // set active list
            $('.js-vpm li').removeClass('active');
            $('.js-vpm li[data-vp-id="'+id+'"]').addClass('active');
            // set active virtual page
            $('.js-vp').removeClass('active');
            $('.js-vp[data-vp-id="'+id+'"]').addClass('active');
        }

        // select change
        $('.js-vpm-select').on( 'change', function ( event ) {
            activate_virtual_page( $(this).find('option:selected').val() );
        });

        // list click
        $('.js-vp-activate').on( 'click', function ( event ) {
            // prevent default
            event.stopPropagation();
            event.preventDefault();
            //
            activate_virtual_page( $(this).data('vp-id') );
        });
    }

    /**
     * Virtual pages XS.
     */

    if ( $('.js-vpms').length )
    {
        $('.js-vpms li').on( 'click', function ( event ) {
            // prevent default
            event.stopPropagation();
            event.preventDefault();
            //
            var menu = $(this).parent();
            if ( menu.hasClass('menu-open') )
            {
                var key = $(this).data('key');
                // close menu
                menu.removeClass('menu-open');
                // show virtual page
                $('.js-vp').removeClass('active');
                $('.js-vp[data-vp-id="'+key+'"]').addClass('active');
                // move menu item to top
                $(this).prependTo( menu );
            }
            else
            {
                // open menu
                menu.addClass('menu-open');
            }
        });
    }

    /**
     * Sliders.
     */

    if ( $('.js-slider-1').length )
    {
        console.log( 'Slider 1 detected.' );

        var slider1 = tns({
            container: '.js-slider-1',
            controls: false,
            nav: false,
            mouseDrag: true,
            fixedWidth: 350,
            loop: false,
        });

        $('.js-slider-1-goto').on( 'click', function ( event ) {
            // prevent default
            event.stopPropagation();
            event.preventDefault();
            //
            if ( $(this).hasClass('prev') ) {
                slider1.goTo('prev');
            } else {
                slider1.goTo('next');
            }
        });
    }

    if ( $('.js-slider-1b').length )
    {
        console.log( 'Slider 1b detected.' );

        var slider1b = tns({
            container: '.js-slider-1bxxx',
            controls: false,
            nav: false,
            mouseDrag: true,
            items: 1.25,
            loop: false,
            responsive: {
                576: {
                    items: 1.8,
                },
                768: {
                    items: 2.8,
                },
                992: {
                    items: 3.6,
                },
            }
        });

        $('.js-slider-1b-goto').on( 'click', function ( event ) {
            // prevent default
            event.stopPropagation();
            event.preventDefault();
            //
            if ( $(this).hasClass('prev') ) {
                slider1b.goTo('prev');
            } else {
                slider1b.goTo('next');
            }
        });
    }

    if ( $('.js-slider-1c').length )
    {
        console.log( 'Slider 1c detected.' );

        var slider1c = tns({
            container: '.js-slider-1c',
            controls: false,
            nav: false,
            mouseDrag: true,
            fixedWidth: 350,
            loop: false,
        });

        $('.js-slider-1c-goto').on( 'click', function ( event ) {
            // prevent default
            event.stopPropagation();
            event.preventDefault();
            //
            if ( $(this).hasClass('prev') ) {
                slider1c.goTo('prev');
            } else {
                slider1c.goTo('next');
            }
        });
    }

    if ( $('.js-slider-2').length )
    {
        console.log( 'Slider 2 detected.' );

        var slider2 = tns({
            container: '.js-slider-2',
            controls: false,
            nav: false,
            mouseDrag: true,
            items: 1.3,
            loop: true,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            responsive: {
                576: {
                    items: 1.6,
                },
                768: {
                    items: 2.2,
                },
            }
        });
    }

    if ( $('.js-slider-3').length )
    {
        console.log( 'Slider 3 detected.' );

        var slider3 = tns({
            container: '.js-slider-3',
            controls: false,
            nav: false,
            mouseDrag: true,
            items: 2,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive: {
                375: {
                    items: 2.5,
                },
                576: {
                    items: 3.5,
                },
                768: {
                    items: 4.5,
                },
                992: {
                    items: 5.5,
                },
            }
        });
    }

    /**
     * Go to.
     */

    if ( $('.js-goto').length )
    {
        $('.js-goto, .js-goto a').on( 'click', function ( event ) {
            // prevent default
            event.stopPropagation();
            event.preventDefault();
            // close mobile nav
            $('#nav-mobile').removeClass('active');
            $('body').removeClass('no-scrolling');
            // goto
            $('html').animate({
                scrollTop: $( $(this).attr('href') ).offset().top
            }, 0 );
        });
    }

    /**
     * Miami subset.
     */

    if ( $('.js-vsc-select').length )
    {
        $('.js-vsc-select').on( 'change', function ( event ) {
            var term_id = $(this).find('option:selected').val();
            Cookies.set( 'vsc', term_id, { sameSite: 'strict', expires: 3 } );
            location.reload();
        });
    }

})( jQuery );
